// extracted by mini-css-extract-plugin
module.exports = {"timerLayout":"PassiveTimer_timerLayout__1lVaT","timerText":"PassiveTimer_timerText__3taR6","claimLabel":"PassiveTimer_claimLabel__xFuVb"};